










































































































































import { Event } from '@ssp/inscreva-sse-models';
import { Component, Prop, Vue } from 'vue-property-decorator';

import { EventDateHelper } from '../services/EventDateHelper';
import { eventUIStore } from '../store/event-ui';
import CountDown from './CountDownComponent.vue';

@Component({
  components: {
    CountDown,
  },
})
export default class SignInComponent extends Vue {
  @Prop({ required: true })
  event: Event;

  email: string | null = null;

  accessKey: string | null = null;

  isFetching = false;

  exceptionMessage: string | null = null;

  showVoucher = false;

  async submit() {
    const fetchOptions = {
      alias: this.event.alias,
      email: this.email,
      accessKey: this.accessKey,
    };

    this.isFetching = true;
    const response = await eventUIStore.getAccess(fetchOptions);

    this.isFetching = false;
    this.exceptionMessage = null;
    this.successMessage = null;

    if (response.status) {
      const error = response.data;

      this.exceptionMessage = error.message;
    } else {
      window.location.href = response.link;
    }
  }

  get eventDate() {
    return EventDateHelper.getDate(this.event.info.date, true);
  }

  // VOUCHER RECOVERY
  isVoucherRecover = false;

  successMessage: string | null = null;

  emailToRecoverVoucher: string | null = null;

  async sendVoucherRecover() {
    const fetchOptions = {
      alias: this.event.alias,
      email: this.emailToRecoverVoucher,
    };

    this.isFetching = true;
    const response = await eventUIStore.resendEmail(fetchOptions);

    this.isFetching = false;
    this.exceptionMessage = null;
    this.successMessage = null;

    if (response.status && response.status !== 'success') {
      const error = response.data;

      this.exceptionMessage = error.message;
    } else {
      this.exceptionMessage = null;
      this.successMessage = 'O voucher foi enviado ao seu E-mail';
      this.isVoucherRecover = false;
    }
  }

  handleVoucherRecover() {
    this.successMessage = null;
    this.exceptionMessage = null;
    this.isVoucherRecover = true;
  }
}
